import { updateObject } from 'utils/updateObject'

const initialState = {
  initialized: false,
  enabled: false,
}

const set2FAState = (state, { payload }) =>
  updateObject(state, { ...payload, initialized: true })

const reset2FAState = () => ({ ...initialState })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/SET_2FA':
      return set2FAState(state, action)
    case 'USER/RESET_2FA':
      return reset2FAState(state, action)
    default:
      return state
  }
}

export default reducer
